<ng-container
  *ngFor="let portal of portal$ | async"
  [cdkPortalOutlet]="portal"
></ng-container>
